import React from "react";
import { Snackbar, Alert } from "@mui/material"; // ✅ importer Snackbar et Alert

const SnackbarFeedback = ({ snackbar, setSnackbar, bottomNavHeight }) => (
  <Snackbar
    open={snackbar.open}
    autoHideDuration={snackbar.persistent ? null : 5000} // 👈 durée conditionnelle
    onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    sx={{ 
      position: "fixed", // ✅ indispensable
      bottom: `${bottomNavHeight}px`,
      zIndex: 1400 // au-dessus du footer
     }} // ✅ marge dynamique
  >
    <Alert
      onClose={() => setSnackbar(prev => ({ ...prev, open: false }))}
      severity={snackbar.severity}
      sx={{ width: "100%" }}
    >
      {snackbar.emoji} {snackbar.message}
    </Alert>
  </Snackbar>
);

export default SnackbarFeedback; // ✅ export par défaut
